import AxiosApiInstance, {APIBase} from "../AxiosApiInstance";
import {AxiosResponse} from "axios";
import ApiApplicationRenderedModel from "./ApiApplicationRenderedModel";

export const ApiApplicationsSubmitPost: (id: string) => Promise<AxiosResponse<ApiApplicationRenderedModel>> = (id) => {
  return AxiosApiInstance.post(`${APIBase}applications/${id}/submit/`);
};